<template>
    <div>
        <slot :post="post" :imageUrl="imageUrl"></slot>
    </div>
</template>

<script>
import { defineComponent, ref, watch, inject} from 'vue';
import { uniq } from 'lodash';

export default defineComponent({
    name: 'PostItemHub',
    props: {
        post: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const post = ref({});
        const imageUrl = inject('imageUrl');

        watch(
            () => props.post,
            (newPost) => {
                post.value = newPost;
                console.log('ITEM: ', newPost)
            },
            { immediate: true }
        );

        return {
            post: post,
            imageUrl: imageUrl
        }
    }
});
</script>


